import React, { FC, PropsWithChildren } from 'react'

interface LabelProps extends PropsWithChildren {
	title: string
	htmlFor: string
	required?: boolean
}

const Label: FC<LabelProps> = ({ children, title, required, htmlFor }) => {
	return (
		<label htmlFor={htmlFor}>
			<p className="absolute -top-2 left-3 inline-block bg-white px-1 text-xs font-semibold text-gray-400 z-10">
				{title} {required && <span className="text-brand-primary-md">*</span>}
			</p>
			{children}
		</label>
	)
}

export default Label
